import React from 'react';
import ComingSoonPage from './components/ComingSoonPage';

function App() {
    return (
        <div>
            <ComingSoonPage />
        </div>
    );
}

export default App;
